import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Money as MoneyField, Radio, RequiredValidator, TextField, useFormContext } from '../../Components/Form';
import Money from '../../Components/Formatting/Money';
import Grid from '../../Components/Formatting/Grid';

const ChargePaymentMethod = ({customer, chargePaymentMethod, isOpen, setIsOpen}) => {
    return <Modal title="Charge payment method" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer, chargePaymentMethod}} />}
    </Modal>
}

const Inner = ({customer, chargePaymentMethod}) => {
    return <Form data={{amount: 0}} onSubmit={chargePaymentMethod} closeModalOnSubmit>
        <Radio name="paymentMethodId"
            label="Payment method"
            validators={[RequiredValidator]}
            emptyMessage={"The customer hasn't added any payment methods yet."}
            options={
                customer.paymentMethods.map(paymentMethod => ({
                    value: paymentMethod.id,
                    label: `${paymentMethod.paymentMethod} - ${paymentMethod.title}`
                }))
            }
        />
        <MoneyField name="amount" label="Amount" validators={[RequiredValidator]} />
        <TextField name="description" label="Reason for charge" validators={[RequiredValidator]} />
        <Result customer={customer} />
        <Actions submit={{label: 'Charge'}} cancel />
    </Form>
}

const Result = ({customer}) => {
    const {formData} = useFormContext();
    const currentBalance = parseInt(customer.balance ?? 0);
    const amount = parseInt(formData.amount ?? 0);
    const newBalance = currentBalance + amount;

    return (
        <Grid items={[
            ['Current Balance:', <Money pence={currentBalance} colour />],
            ['After charge:', <Money pence={newBalance} colour />]
        ]} />
    );
}

export default ChargePaymentMethod;
